import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { chainesLocales } from './../include/chainesLocales';

class Consignes extends Component {
    get labels() {
        return chainesLocales['Consignes'][this.props.lang];
    }

    jaiCompris(evt) {
        evt.target.disabled = true;

        this.props.onPageSuccess();
    }

    render() {
        return (
            <div className="text-left">
                <h1 className="text-left">
                    {this.props.suffixe === "e366f" || this.props.suffixe === "e366e" ? this.labels.titleNoQuest : this.labels.title}
                </h1>
                <div className="row">
                    <div className="col text-justify">
                        <div className="mb-3 mes-consignes" dangerouslySetInnerHTML={{__html: this.props.config[`MES_CONSIGNE_${this.props.lang}`]}} />
                    </div>
                </div>
                <div className="row align-items-end mt-3">
                    <div className="col">
                        <button className="btn btn-primary" onClick={this.jaiCompris.bind(this)}>{this.labels.button}</button>
                    </div>
                </div>
            </div>
        );
    }
}

Consignes.propTypes = {
    lang: PropTypes.oneOf(['FR', 'AN', 'CR', 'CS']).isRequired,
    onPageSuccess: PropTypes.func.isRequired
}

Consignes.defaultProps = {
    lang: "FR"
}

export default Consignes;